module.exports = __webpack_public_path__ + "static/media/alarm.0a890723.svg";